import React from 'react';
import {
    AppBar,
    Toolbar,
    Typography,
    Dialog,
    IconButton,
    TextField,
    Button,
    DialogActions,
    DialogTitle,
    DialogContentText,
    DialogContent,
    CircularProgress,
    Tooltip,
    Tabs,
    Tab,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    FormControlLabel,
    Checkbox
} from '@material-ui/core/';
import { OptionField, BOOL_TRUE, BOOL_FALSE } from './algorithmOptions';
import Moment from 'moment';

import DeleteIcon from '@material-ui/icons/Delete';
import CodeIcon from '@material-ui/icons/Code';
import SaveIcon from '@material-ui/icons/Save';
import SaveCopyIcon from '@material-ui/icons/FileCopy';
import PersonAddIcon from '@material-ui/icons/PersonAdd';
import ImageIcon from '@material-ui/icons/Image';
import LogsIcon from '@material-ui/icons/List';
import DownloadIcon from '@material-ui/icons/CloudDownload';
import AddIcon from '@material-ui/icons/Add'
import CanceIcon from '@material-ui/icons/Cancel';
//import CopyIcon from '@material-ui/icons/FileCopyOutlined'
import NavigationClose from '@material-ui/icons/Close';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import KeepIcon from '@material-ui/icons/Favorite';
import PlayIcon from '@material-ui/icons/PlayArrow';

import Config from '@apricityhealth/web-common-lib/Config';
import Axios from '@apricityhealth/web-common-lib/utils/Axios';
import LogsView from '@apricityhealth/web-common-lib/views/LogsView';
import EnhancedTable from "@apricityhealth/web-common-lib/components/EnhancedTable";
import SelectDataType from '@apricityhealth/web-common-lib/components/SelectDataType';
import SelectTupleIndex from '@apricityhealth/web-common-lib/components/SelectTupleIndex';
import { toBoolean } from '@apricityhealth/web-common-lib/utils/Utils';
import getErrorMessage from '@apricityhealth/web-common-lib/utils/getErrorMessage';
import SelectUser from '@apricityhealth/web-common-lib/components/SelectUser';
import User from '@apricityhealth/web-common-lib/components/User';
import EditConditions from '@apricityhealth/web-common-lib/components/EditConditions';

import JSONDataDialog from '../dialogs/JSONDataDialog';
import EditDataTypeDialog from '../dialogs/EditDataTypeDialog';
import createIdFromText from '../utils/CreateIdFromText';
import ChangedByButton from '../components/ChangedByButton';
import FeatureSelectionView from './FeatureSelectionView';
import TriggerSelectionView from './TriggerSelectionView';
import { DATE_FORMAT } from './clusteringView/EventChangesView';
import { loadJobResult } from '../utils/LoadJobResults';
import { getReportSeries } from '@apricityhealth/web-common-lib/utils/Services';

const FileDownload = require('js-file-download');

const PNG_IMAGE = 'data:image/png;base64,';

// Add JSON.parseMore, to allow us to parse python generated JSON data..
require('../utils/json_parseMore');

export class MLModelView extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            progress: null,
            algorithms: [],
            deployments: [],        // end-points earlier runs of this model left standing
            // Chosen per RUN, not stored on the model. 'train' is an ordinary run; 'keep' leaves the end-point
            // standing afterwards; 'reuse' infers against one that is already up and skips training entirely.
            jobMode: 'train',
            jobDeployId: '',
            // Overrides for THIS run only. Deliberately not written back to the model: a one-off experiment
            // that quietly re-saved the model would change every later run, including its schedule.
            jobOpts: {},
            imports: [],
            // Who the caller is, per the SERVER rather than a token decoded here — the same reason
            // getMLSharedFolders returns it: a second answer derived in the client is a second answer that
            // can disagree with the one the API is actually enforcing.
            currentUserId: '',
            addOwnerId: '',         // the picker above the owner list
            copyToUserId: '',       // the picker in "give someone their own copy"
            recurring: false,
            runWhen: new Date(),
            interval: 1,
            intervalType: 'days',
            model: {
                modelId: '',
                name: '',
                description: '',
                algorithm: 'kmeans',
                opts: {},
                biomarkers: {
                    importId: '',
                    dataId: '',
                    tupleIndex: 0,
                    value: [],
                    condition: '',
                    demographics: [],
                    labs: [],
                    labs_normal: [],
                    labs_high: [],
                    labs_low: [],
                    conditions: [],
                    medications: [],
                    procedures: [],
                }
            },
            counts: {},
            tab: '0'
        };
    }

    componentDidMount() {
        this.loadCurrentUser();
        if (this.props.model)
            this.loadModel(this.props.model);
        this.loadJobsTimer = setInterval(this.loadJobs.bind(this), 15 * 1000);
        this.loadImportsTimer = setInterval(this.loadImports.bind(this), 20 * 1000 );
        this.loadAlgorithms();
        this.loadImports();
    }

    componentWillUnmount() {
        clearInterval(this.loadJobsTimer);
        clearInterval(this.loadImportsTimer)
    }

    componentDidUpdate(oldProps) {
        if (this.props.model !== oldProps.model)
            this.loadModel(this.props.model);
    }

    onCloseView() {
        console.log("closeView()", this);
        this.props.onClose();
    }

    loadModel(model) {
        console.log("loadModel:", model);
        if (typeof model.biomarkers.value === 'string') {
            model.biomarkers.value = model.biomarkers.value.split(',')
        }

        this.setState({
            model,
            dialog: null
        }, () => { this.loadJobs(); this.loadDeployments(); });
    }

    /**
     * The algorithm a model refers to.
     *
     * `model.algorithm` holds a qualified reference (`system/kmeans`, `users/<id>/mine`). Models saved before
     * the algorithm store existed hold a bare name, which the server resolves to `system/<name>` — so the
     * fallback below is not defensive padding, it is how every pre-existing model keeps working.
     */
    algorithmFor(model) {
        const { algorithms } = this.state;
        const ref = model && model.algorithm;
        if (!ref) return null;
        return (algorithms || []).find((a) => a.ref === ref)
            || (algorithms || []).find((a) => a.ref === `system/${ref}`)
            || null;
    }

    loadAlgorithms() {
        const { appContext: { state: { idToken } } } = this.props;
        const getFeatureDetectAlgorithms = {
            url: Config.baseUrl + `${Config.pathPrefix}apricity-forecast/ml/algorithms`,
            method: 'GET',
            headers: { "Authorization": idToken }
        }
        console.log("getFeatureDetectAlgorithms request:", getFeatureDetectAlgorithms);
        Axios(getFeatureDetectAlgorithms).then(({ data: { algorithms } }) => {
            console.log("getFeatureDetectAlgorithms result:", algorithms);
            this.setState({ algorithms });
        }).catch((err) => {
            this.setState({ error: getErrorMessage(err) });
        })
    }

    loadImports() {
        const { appContext: { state: { idToken } } } = this.props;
        const getImports = {
            url: Config.baseUrl + `${Config.pathPrefix}patients/imports`,
            method: 'GET',
            headers: { "Authorization": idToken }
        }
        console.log("getImports request:", getImports);
        Axios(getImports).then(({ data }) => {
            console.log("getImports result:", data);
            this.setState({ imports: data });
        }).catch((err) => {
            this.setState({ error: getErrorMessage(err) });
        })
    }

    /**
     * End-points this model's earlier runs left standing.
     *
     * Recorded by the service when a run's result resolves the algorithm's `deploy.output` paths — so this list
     * is empty until a run actually kept one, which is the honest signal that there is nothing to re-use yet.
     */
    /**
     * Open the create-job dialog on a clean slate.
     *
     * `onCreateJob` re-renders itself on every change, so it cannot also be the entry point — it would inherit
     * whatever the last run was set up with, which for a re-use is a deployment the user did not pick this time.
     */
    onNewJob() {
        this.setState({ jobMode: 'train', jobDeployId: '', jobOpts: {} }, this.onCreateJob.bind(this));
    }

    loadDeployments() {
        const { appContext: { state: { idToken, plan: { planId } } } } = this.props;
        const { model } = this.state;
        if (!model || !model.modelId) return;
        Axios({
            url: Config.baseUrl + `${Config.pathPrefix}apricity-forecast/${planId}/ml/deployment`,
            method: 'GET',
            headers: { Authorization: idToken },
            params: { modelId: model.modelId }
        }).then(({ data }) => {
            this.setState({ deployments: (data && data.deployments) || [] });
        }).catch((err) => {
            this.setState({ error: getErrorMessage(err) });
        });
    }

    /**
     * Run this model against a standing end-point: inference on the current cohort, no training.
     *
     * The service does the rest — it merges the deployment's end-point names into the job's options and forces
     * `train: False`. Nothing about the cohort is carried over, which is the point: the model's biomarkers are
     * read fresh, so this is how the same trained model gets applied to new data.
     */
    onRunWithDeployment(deployment) {
        const { appContext: { state: { idToken, plan: { planId } } } } = this.props;
        const { model } = this.state;
        this.setState({ progress: <CircularProgress size={20} />, error: null });
        Axios({
            url: Config.baseUrl + `${Config.pathPrefix}apricity-forecast/${planId}/ml/job`,
            method: 'POST',
            headers: { Authorization: idToken },
            data: { modelId: model.modelId, deployId: deployment.deployId }
        }).then(() => {
            this.setState({ progress: null, tab: '1' }, this.loadJobs.bind(this));
        }).catch((err) => {
            this.setState({ progress: null, error: getErrorMessage(err) });
        });
    }

    onDeleteDeployment(deployment) {
        const { appContext: { state: { idToken, plan: { planId } } } } = this.props;
        this.setState({
            dialog: <Dialog open={true}>
                <DialogTitle>Shut this deployment down?</DialogTitle>
                <DialogContent>
                    <div>
                        These end-points are deleted in SageMaker, which stops them billing:
                        {' '}<b>{Object.values(deployment.outputs || {}).join(', ')}</b>
                    </div>
                    <div style={{ marginTop: 10 }}>
                        The trained model is not affected — a later run can stand a new end-point up from it
                        without retraining.
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => this.setState({ dialog: null })}>Cancel</Button>
                    <Button color="secondary" onClick={() => {
                        this.setState({ dialog: null, progress: <CircularProgress size={20} /> });
                        Axios({
                            url: Config.baseUrl + `${Config.pathPrefix}apricity-forecast/${planId}`
                                + `/ml/deployment/${deployment.deployId}`,
                            method: 'DELETE',
                            headers: { Authorization: idToken }
                        }).then(() => {
                            this.setState({ progress: null }, this.loadDeployments.bind(this));
                        }).catch((err) => {
                            this.setState({ progress: null, error: getErrorMessage(err) });
                        });
                    }}>Shut down</Button>
                </DialogActions>
            </Dialog>
        });
    }

    loadJobs() {
        const { appContext: { state: { idToken, plan: { planId } } } } = this.props;
        const { model } = this.state;
        if (model && model.modelId) {
            this.setState({ error: null });
            const getFeatureDetectJobs = {
                url: Config.baseUrl + `${Config.pathPrefix}apricity-forecast/${planId}/ml/job/*?modelId=${model.modelId}`,
                method: 'GET',
                headers: { "Authorization": idToken }
            }
            Axios(getFeatureDetectJobs).then(({ data: { jobs } }) => {
                this.setState({ jobs });
            }).catch((err) => {
                this.setState({ error: getErrorMessage(err) });
            })
        }
    }

    /**
     * Ask the service who the caller is.
     *
     * `/ml/shared` answers it as a side effect of listing shared algorithm folders, which is not what this
     * view wants it for — but it is the endpoint that already knows, and adding a second source of the same
     * fact is how two of them start disagreeing. Failure is silent: the owner list still renders, it just
     * cannot mark which row is you.
     */
    loadCurrentUser() {
        const { appContext: { state: { idToken } } } = this.props;
        if (!idToken) return;
        Axios({
            url: Config.baseUrl + `${Config.pathPrefix}apricity-forecast/ml/shared`,
            method: 'GET',
            headers: { "Authorization": idToken }
        }).then((response) => {
            this.setState({ currentUserId: (response.data && response.data.userId) || '' });
        }).catch((err) => {
            console.warn("loadCurrentUser failed, the owner list will not mark which row is you:", err);
        });
    }

    /** Everyone who owns this model. Legacy rows hold a bare string rather than an array. */
    ownersOf(model) {
        const owners = model && model.ownerId;
        if (Array.isArray(owners)) return owners.filter(Boolean);
        return owners ? [owners] : [];
    }

    onAddOwner() {
        const { model, addOwnerId } = this.state;
        if (!addOwnerId) return;
        const owners = this.ownersOf(model);
        if (owners.includes(addOwnerId)) return;
        model.ownerId = [...owners, addOwnerId];
        this.setState({ model, addOwnerId: '', modified: true });
    }

    onRemoveOwner(userId) {
        const { model } = this.state;
        model.ownerId = this.ownersOf(model).filter((u) => u !== userId);
        this.setState({ model, modified: true });
    }

    /**
     * Hand someone their own copy: a NEW model, owned by them alone.
     *
     * Deliberately not `onSaveMLModel(true)`. That one deletes `modelId` off the model **in state** so the
     * server allocates a new one — fine for duplicating a model for yourself, but it keeps the current owners
     * and it mutates the record this view is still editing. Here the payload is built separately, so the
     * model on screen is untouched whether this succeeds or fails.
     */
    onGiveCopy() {
        const { model, copyToUserId } = this.state;
        const { appContext: { state: { idToken, plan: { planId } } } } = this.props;
        if (!copyToUserId) return;

        const copy = {
            ...model,
            // biomarkers is cloned rather than shared: the filter below would otherwise edit the array the
            // open model is still using.
            biomarkers: {
                ...model.biomarkers,
                value: ((model.biomarkers && model.biomarkers.value) || []).filter((e) => e)
            },
            ownerId: [copyToUserId]
        };
        delete copy.modelId;            // absent means "new model" to saveMLModel
        delete copy._id;
        delete copy.__v;
        delete copy.history;            // theirs starts fresh; ours is not their edit history
        delete copy.enableJobSchedule;
        delete copy.nextJobScheduled;
        delete copy.interval;
        delete copy.intervalType;

        this.setState({ progress: <CircularProgress size={20} />, error: null });
        Axios({
            url: Config.baseUrl + `${Config.pathPrefix}apricity-forecast/${planId}/ml/`,
            method: 'POST',
            headers: { "Authorization": idToken },
            data: copy
        }).then((response) => {
            console.log("onGiveCopy response:", response.data);
            this.setState({ progress: null, copyToUserId: '', copyGiven: copyToUserId });
        }).catch((error) => {
            this.setState({ progress: null, error: getErrorMessage(error) });
        });
    }

    /**
     * Sharing: co-ownership, and handing over a copy.
     *
     * The two are separated on purpose because they are easy to confuse and hard to undo the wrong way round.
     * Sharing makes the OTHER person an owner of THIS model — one record, so anyone's edit is everyone's.
     * A copy is a new model owned by them, which then drifts from yours. The captions say which is which at
     * the moment of choosing rather than in a tooltip nobody opens.
     *
     * Owner edits ride on the model's own Save, like every other field here — a share that applied instantly
     * while the rest of the form waited for Save would be the odd one out, and there would be no way to
     * change your mind. The copy is immediate, because there is nothing on this form for it to be part of.
     */
    renderSharing() {
        const { appContext } = this.props;
        const { model, currentUserId, addOwnerId, copyToUserId, copyGiven } = this.state;
        const owners = this.ownersOf(model);
        const isNew = !model.modelId;
        // The server keeps the existing owners when it is sent an empty list -- it will not orphan a model --
        // so removing the last one would silently do nothing. Better to not offer it.
        const onlyOwner = owners.length <= 1;
        const iAmOwner = !currentUserId || owners.includes(currentUserId);

        return <Accordion style={{ margin: 5, marginLeft: 15, marginRight: 15 }}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                Sharing{owners.length ? ` (${owners.length} owner${owners.length === 1 ? '' : 's'})` : ''}
            </AccordionSummary>
            <AccordionDetails>
                <div style={{ width: '100%' }}>
                    {isNew
                        ? <Typography variant="caption">
                            Save the model first — it belongs to you once it exists, and can be shared after that.
                        </Typography>
                        : <React.Fragment>
                            <Typography variant="caption">
                                Everyone below owns this model: they can see it, edit it, run it and see its
                                jobs. It stays one model, so a change by any owner is a change for all of them.
                            </Typography>

                            <div style={{ display: 'flex', alignItems: 'flex-end', marginTop: 10 }}>
                                <SelectUser appContext={appContext} userId={addOwnerId} label="Add an owner"
                                    onChange={(userId) => this.setState({ addOwnerId: userId })} />
                                <Button color="primary" startIcon={<PersonAddIcon />}
                                    disabled={!addOwnerId || owners.includes(addOwnerId)}
                                    onClick={this.onAddOwner.bind(this)}>Add</Button>
                            </div>

                            <div style={{ marginTop: 10 }}>
                                {owners.map((userId) => <div key={userId}
                                    style={{ display: 'flex', alignItems: 'center', maxWidth: 520 }}>
                                    <span style={{ flexGrow: 1 }}>
                                        <User appContext={appContext} userId={userId} />
                                        {userId === currentUserId
                                            ? <i style={{ opacity: 0.7 }}> — you</i> : null}
                                    </span>
                                    <Tooltip title={onlyOwner
                                        ? 'A model keeps at least one owner — add someone else first'
                                        : 'Remove this owner'}>
                                        <span>
                                            <IconButton size="small" disabled={onlyOwner}
                                                onClick={() => this.onRemoveOwner(userId)}>
                                                <DeleteIcon fontSize="small" />
                                            </IconButton>
                                        </span>
                                    </Tooltip>
                                </div>)}
                            </div>

                            {!iAmOwner && <Typography variant="caption" style={{ color: 'red', display: 'block' }}>
                                You are not in this list. Saving hands the model over and you lose access to it.
                            </Typography>}
                            <Typography variant="caption" style={{ display: 'block', opacity: 0.7 }}>
                                Owner changes are saved with the model — press Save.
                            </Typography>

                            <div style={{ borderTop: '1px solid rgba(0,0,0,0.12)', marginTop: 15, paddingTop: 10 }}>
                                <Typography variant="subtitle2">Give someone their own copy</Typography>
                                <Typography variant="caption">
                                    Creates a separate model belonging to them alone. Yours is left exactly as
                                    it is, and neither one's later edits reach the other.
                                </Typography>
                                <div style={{ display: 'flex', alignItems: 'flex-end', marginTop: 5 }}>
                                    <SelectUser appContext={appContext} userId={copyToUserId} label="Copy to"
                                        onChange={(userId) => this.setState({ copyToUserId: userId, copyGiven: null })} />
                                    <Button color="primary" startIcon={<SaveCopyIcon />} disabled={!copyToUserId}
                                        onClick={this.onGiveCopy.bind(this)}>Give a copy</Button>
                                </div>
                                {copyGiven && <Typography variant="caption" style={{ color: 'green' }}>
                                    A copy now belongs to <User appContext={appContext} userId={copyGiven} />.
                                </Typography>}
                            </div>
                        </React.Fragment>}
                </div>
            </AccordionDetails>
        </Accordion>;
    }

    onSaveMLModel( copy = false ) {
        const { model } = this.state;
        const { appContext: { state: { idToken, plan: { planId } } } } = this.props;

        // clean up the model.opts, so we don't keep old options from other algorithms
        const algorithmOptions = (this.algorithmFor(model) || { opts: [] }).opts;
        for (let k in model.opts) {
            if (!algorithmOptions.find((e) => e.name === k)) {
                delete model.opts[k];       // option not found, so remove it..
            }
        }

        this.setState({ progress: <CircularProgress size={20} />, error: null });

        delete model.enableJobSchedule;
        delete model.nextJobScheduled;
        delete model.interval;
        delete model.intervalType;
        delete model._id;
        delete model.__v;
        
        if ( copy ) {
            delete model.modelId
        }
        model.biomarkers.value = model.biomarkers.value.filter((e) => e);           // remove empty strings from the array at save

        const saveMLModel = {
            url: Config.baseUrl + `${Config.pathPrefix}apricity-forecast/${planId}/ml/`,
            method: 'POST',
            headers: { "Authorization": idToken },
            data: model
        };
        console.log("saveMLModel request:", saveMLModel)
        Axios(saveMLModel).then((response) => {
            console.log("saveMLModel response:", response.data);
            this.setState({ model: response.data, progress: null }, copy ? this.loadJobs.bind(this) : undefined );
        }).catch((error) => {
            this.setState({ progress: null, error: getErrorMessage(error) });
        });
    }

    onDeleteMLModel() {
        this.setState({
            dialog: <div>
                <Dialog
                    model="false"
                    open={true}>
                    <DialogTitle>Delete model: {`${this.state.model.modelId}`}</DialogTitle>
                    <DialogContent>
                        <DialogContentText>Are you sure you want to delete?</DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button variant="contained" style={{margin: 5}} onClick={this.onCloseDialog.bind(this)}>Cancel</Button>,
                        <Button variant="contained" style={{ margin: 5 }} onClick={this.onConfirmDelete.bind(this)}>Confirm</Button>
                    </DialogActions>
                </Dialog>
            </div>
        });
    }

    onShowCode() {
        let { appContext } = this.props;
        let { model } = this.state;
        this.setState({
            dialog: <JSONDataDialog
                appContext={appContext}
                dataType={model}
                onDone={() => {
                    this.setState({ dialog: null });
                }}
            />
        });
    }

    onCloseDialog() {
        this.setState({ dialog: null });
    }

    onConfirmDelete() {
        const self = this;
        const { model } = this.state;
        const { appContext: { state: { idToken, plan: { planId } } } } = this.props;

        self.setState({ dialog: null });
        if (model && model.modelId) {
            this.setState({ progress: <CircularProgress size={20} />, error: null });
            const deleteFeatureDetectModel = {
                url: Config.baseUrl + `${Config.pathPrefix}apricity-forecast/${planId}/ml/${model.modelId}`,
                method: 'DELETE',
                headers: { "Authorization": idToken }
            };
            Axios(deleteFeatureDetectModel).then((result) => {
                console.log("deleteFeatureDetectModel result:", result.data);
                self.setState({ progress: null });
                self.onCloseView();
            }).catch((error) => {
                console.log("deleteFeatureDetectModel error:", error.response);
                self.setState({ progress: null, error: getErrorMessage(error) });
            });
        }
    }

    /**
     * Set up one run.
     *
     * Everything here is per-run and none of it touches the model. That separation is the point: the model says
     * what the algorithm and the cohort are, the run says what to do with them this time — train fresh, keep the
     * end-point, or skip training and infer against one that is already up.
     *
     * The option overrides start from the model's saved values and are shown so it is obvious what will
     * actually be sent. For a recurring job they become that schedule's standing options, which is why they are
     * labelled as applying to the run rather than silently merged into the model.
     */
    onCreateJob() {
        const { appContext: { state: { idToken, plan: { planId } } } } = this.props;
        const { model, recurring, runWhen, interval, intervalType, deployments, jobMode, jobDeployId,
            jobOpts } = this.state;
        const algorithm = this.algorithmFor(model) || { opts: [] };
        const usable = (deployments || []).filter((d) => d.algorithm === model.algorithm);
        // Model values are the defaults; jobOpts holds only what has been changed this time.
        const optValue = (name) => (jobOpts[name] !== undefined ? jobOpts[name] : (model.opts || {})[name] || '');

        /**
         * What the run type dictates for an option, or undefined when it dictates nothing.
         *
         * Returned as the value to DISPLAY, not just a flag, because a greyed-out checkbox still has to be
         * right — "Train and keep the end-point" left `deploy` showing the model's unchecked value while the
         * run was about to send True, which is the disabled control lying about the outcome.
         *
         * Each mode manages only what it actually decides. 'keep' says nothing about which training job to
         * attach to, so those fields stay editable.
         */
        const dictated = (name) => {
            if (jobMode === 'keep') {
                // deploy implies train — the Python forces it, so show it that way rather than let the two
                // boxes disagree.
                if (name === 'train' || name === 'deploy') return BOOL_TRUE;
                return undefined;
            }
            if (jobMode === 'reuse') {
                // Supplying an end-point name forces both off inside the algorithm, whatever is passed.
                if (name === 'train' || name === 'deploy') return BOOL_FALSE;
                const chosen = usable.find((d) => d.deployId === jobDeployId);
                if (/_endpoint_name$/.test(name)) {
                    return (chosen && chosen.outputs && chosen.outputs[name]) || '';
                }
                // Irrelevant once an end-point is supplied: there is nothing left to attach to or train.
                if (/_training_job_name$/.test(name)) return '';
                return undefined;
            }
            return undefined;
        };

        const dialog = <Dialog open={true} maxWidth="md" fullWidth>
            <DialogTitle>Create job — {model.name || model.modelId}</DialogTitle>
            <DialogContent>
            <FormControl style={{ width: 320, marginRight: 15 }}>
                <InputLabel>What should this run do?</InputLabel>
                <Select value={jobMode} onChange={(e) =>
                    this.setState({ jobMode: e.target.value }, this.onCreateJob.bind(this))}>
                    <MenuItem value='train'>Train, predict, then release the end-point</MenuItem>
                    <MenuItem value='keep'>Train and keep the end-point for re-use</MenuItem>
                    <MenuItem value='reuse' disabled={!usable.length}>
                        {usable.length ? 'Re-use a deployed end-point (no training)'
                            : 'Re-use a deployed end-point — none available yet'}
                    </MenuItem>
                </Select>
            </FormControl>
            {jobMode === 'reuse' && <FormControl style={{ width: 380 }}>
                <InputLabel>End-point</InputLabel>
                <Select value={usable.some((d) => d.deployId === jobDeployId) ? jobDeployId : ''}
                    onChange={(e) => this.setState({ jobDeployId: e.target.value }, this.onCreateJob.bind(this))}>
                    {usable.map((d) => <MenuItem key={d.deployId} value={d.deployId}>
                        {Moment(d.createdAt).format(DATE_FORMAT)} — {Object.values(d.outputs || {}).join(', ')}
                    </MenuItem>)}
                </Select>
            </FormControl>}
            <div style={{ marginTop: 8, opacity: 0.75, fontSize: 13 }}>
                {jobMode === 'train' && 'The end-point is created for the predictions and deleted afterwards.'}
                {jobMode === 'keep' && 'Costs money until you shut it down from the Deployments tab, and lets '
                    + 'later runs skip training entirely.'}
                {jobMode === 'reuse' && 'Applies the already-trained model to whatever the cohort holds now. '
                    + 'No training, and the end-point stays up.'}
            </div>
            <br />
            <FormControlLabel label="Recurring Job?" control={<Checkbox checked={recurring} onChange={(e,v) => {
                this.setState({recurring: !recurring}, this.onCreateJob.bind(this) );
            }} />} />
            <br />
            {recurring && <TextField style={{ width: 300, margin: 5}} value={Moment(runWhen).format('yyyy-MM-DDTHH:mm')} type='datetime-local' label='Run Job When' onChange={(e) => {
                const value = Moment(e.target.value);
                if ( value.isValid() ) {
                    this.setState({runWhen: value.toDate()}, this.onCreateJob.bind(this))
                }
            }} />}
            {recurring && <TextField style={{width: 200, margin: 5}} value={interval} type='number' label='Interval' onChange={(e) => {
                this.setState({interval: e.target.value}, this.onCreateJob.bind(this));
            }} />}
            {recurring && <FormControl style={{width: 200, margin: 5}}>
                <InputLabel>Interval Type</InputLabel>
                <Select value={intervalType} onChange={(e) => {
                    this.setState({intervalType: e.target.value}, this.onCreateJob.bind(this));
                }}>
                    <MenuItem value='hours'>Hours</MenuItem>
                    <MenuItem value='days'>Days</MenuItem>
                    <MenuItem value='weeks'>Weeks</MenuItem>
                    <MenuItem value='months'>Months</MenuItem>
                    <MenuItem value='years'>Years</MenuItem>
                </Select>
            </FormControl>}

            <Accordion style={{ marginTop: 10 }}>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    Algorithm options{Object.keys(jobOpts).length ? ` (${Object.keys(jobOpts).length} changed)` : ''}
                </AccordionSummary>
                <AccordionDetails>
                    <div style={{ width: '100%' }}>
                        <div style={{ opacity: 0.75, fontSize: 13, marginBottom: 8 }}>
                            These apply to this run only — the model keeps its own values.
                            {jobMode !== 'train' && ' Training and end-point options are set by the choice above.'}
                        </div>
                        {(algorithm.opts || []).map((opt) => {
                            // Set by the mode, so editing it here would be two controls fighting over one
                            // value — and the losing one would be the visible one.
                            const forced = dictated(opt.name);
                            const managed = forced !== undefined;
                            return <OptionField key={opt.name}
                                opt={opt}
                                value={managed ? forced : optValue(opt.name)}
                                disabled={managed}
                                helperText={managed ? 'set by the run type above' : opt.description}
                                onChange={(value) => this.setState({
                                    jobOpts: { ...jobOpts, [opt.name]: value }
                                }, this.onCreateJob.bind(this))} />;
                        })}
                    </div>
                </AccordionDetails>
            </Accordion>
            </DialogContent>
            <DialogActions>
                <Button onClick={this.onCloseDialog.bind(this)}>Cancel</Button>
                <Button color="primary" disabled={jobMode === 'reuse' && !jobDeployId} onClick={() => {
                    this.onCloseDialog();
                    this.setState({ error: null });

                    // The model's options, overridden by anything changed for this run. The mode contributes
                    // `deploy` for 'keep'; for 'reuse' the service supplies the end-point names and train=False,
                    // because it is the only side that knows what the deployment actually holds.
                    const merged = { ...(model.opts || {}), ...jobOpts };
                    if (jobMode === 'keep') merged.deploy = 'True';

                    const args = [];
                    for (let k in merged) {
                        if (merged[k]) {              // don't pass arguments that are empty
                            args.push(`${k}=${encodeURIComponent(merged[k])}`);
                        }
                    }

                    const createFeatureDetectJob = {
                        url: Config.baseUrl + `${Config.pathPrefix}apricity-forecast/${planId}/ml/job?${args.join('&')}`,
                        method: 'POST',
                        headers: { "Authorization": idToken },
                        data: {
                            planId: model.planId,
                            modelId: model.modelId,
                            ...(jobMode === 'reuse' ? { deployId: jobDeployId } : {}),
                            recurring,
                            runWhen,
                            interval,
                            intervalType
                        }
                    };
                    console.log("createFeatureDetectJob request:", createFeatureDetectJob);
                    Axios(createFeatureDetectJob).then(() => {
                        this.setState({ dialog: null })
                        this.loadJobs();
                    }).catch((err) => {
                        this.setState({ error: getErrorMessage(err) });
                    })
                }}>Create</Button>
            </DialogActions>
        </Dialog>;

        this.setState({ dialog });
    }

    onCancelJob(job) {
        return <Tooltip key='cancelJob' title='Cancel Job'>
            <span><IconButton disabled={job.status !== 'running' && job.status !== 'pending'} onClick={() => {
                this.setState({dialog: <Dialog open={true}>
                    <DialogTitle>Confirm Cancel</DialogTitle>
                    <DialogContent>Please confirm that you want to cancel job {job.jobId}?</DialogContent>
                    <DialogActions>
                        <Button onClick={() => this.setState({dialog: null})}>Cancel</Button>
                        <Button onClick={() => {
                            const { appContext: { state: { idToken } } } = this.props;

                            const cancelJob = {
                                url: Config.baseUrl + `${Config.pathPrefix}apricity-forecast/${job.planId}/ml/job/${job.jobId}/cancel`,
                                method: 'DELETE',
                                headers: { "Authorization": idToken }
                            };
                            console.log("cancelJob request:", cancelJob);
                            Axios(cancelJob).then((result) => {
                                console.log("cancelJob result:", result.data);
                                this.setState({ dialog: null, error: null })
                                this.loadJobs();
                            }).catch((err) => {
                                console.error("cancelJob error:", err );
                                this.setState({ error: getErrorMessage(err) });
                            })
                        }}>Confirm</Button>
                    </DialogActions>
                </Dialog>})
            }}><CanceIcon /></IconButton></span>
        </Tooltip>;
    }

    onDeleteJob(job,table) {
        return <Tooltip key='deleteJob' title='Delete Job'>
            <span><IconButton disabled={job.status === 'pending' || job.status === 'running'} onClick={() => {
                const { appContext: { state: { idToken } } } = this.props;
                this.setState({dialog: <Dialog open={true}>
                    <DialogTitle>Confirm Delete</DialogTitle>
                    <DialogContent>Please confirm you want to delete job {job.jobId}?</DialogContent>
                    <DialogActions>
                        <Button onClick={() => this.setState({dialog: null})}>Cancel</Button>
                        <Button onClick={() => {
                            const deleteJob = {
                                url: Config.baseUrl + `${Config.pathPrefix}apricity-forecast/${job.planId}/ml/job/${job.jobId}`,
                                method: 'DELETE',
                                headers: { "Authorization": idToken }
                            };
                            console.log("deleteJob request:", deleteJob);
                            this.setState({dialog: null});
                            Axios(deleteJob).then((result) => {
                                console.log("deleteJob result:", result.data);
                                table.setState({ selected: [] });
                                this.setState({ dialog: null, error: null })
                                this.loadJobs();
                            }).catch((err) => {
                                console.error("deleteJob error:", err );
                                this.setState({ error: getErrorMessage(err) });
                            })
                        }}>Confirm</Button>
                    </DialogActions>
                </Dialog>});
            }}><DeleteIcon /></IconButton></span>
        </Tooltip>;
    }

    onJobDetails(job) {
        return <Tooltip key='viewDetails' title='View Details'><IconButton onClick={() => {
            this.setState({
                dialog: <JSONDataDialog
                    appContext={this.props.appContext}
                    dataType={job}
                    onDone={() => {
                        this.setState({ dialog: null });
                    }}
                />
            });
        }}><CodeIcon /></IconButton></Tooltip>;
    }

    onToggleKeep(job) {
        return <Tooltip key='toggleKeep' title='Toggle Keep Status'><IconButton onClick={() => {
            job.keep = !job.keep;

            const { appContext: { state: { idToken } } } = this.props;
            const updateJob = {
                url: Config.baseUrl + `${Config.pathPrefix}apricity-forecast/${job.planId}/ml/job/${job.jobId}`,
                method: 'PUT',
                data: { keep: job.keep },
                headers: { "Authorization": idToken }
            };
            console.log("updateJob request:", updateJob);
            Axios(updateJob).then((result) => {
                console.log("updateJob result:", result.data);
            }).catch((err) => {
                this.setState({ error: getErrorMessage(err) });
            })

            this.setState({error: null, job});
        }}><KeepIcon /></IconButton></Tooltip>;
    }

    onViewImage(res) {
        this.setState({
            dialog: <Dialog open={true} maxWidth='xl'>
                <DialogContent>
                    <img src={res} alt='Report Results' />
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => this.setState({ dialog: null })}>Close</Button>
                </DialogActions>
            </Dialog>
        })
    }

    onJobResult(job) {
        let buttons = [];
        if (job.result && job.result.startsWith("data:image/png;base64,")) {
            buttons.push(<Tooltip key='viewImage' title='View Image'>
                <IconButton onClick={() => {
                    this.onViewImage(job.result);
                }}><ImageIcon /></IconButton>
            </Tooltip>);
        }

        buttons.push(<Tooltip key='jobResult' title='Download Result'><span><IconButton disabled={!job.result} onClick={() => {
            function downloadResult(res) {
                try {
                    if (res.startsWith(PNG_IMAGE)) {
                        FileDownload(Buffer.from(res.substring(PNG_IMAGE.length), 'base64'), `job-${job.jobId}-result.png`);
                    } else {
                        const formattedJson = JSON.stringify(JSON.parseMore(res), null, 4);
                        FileDownload(formattedJson, `job-${job.jobId}-result.json`);
                    }
                } catch( err) {
                    console.warn("OnJobResult not json!", err);
                    FileDownload(res, `job-${job.jobId}-result.txt`);
                }
            }

            loadJobResult(this.props.appContext, job).then(() => {
                downloadResult(job.result);
            }).catch((err) => {
                console.error("loadJobResult error:", err );
            })
        }}><DownloadIcon /></IconButton></span></Tooltip>);

        return buttons
    }

    onJobLogs(job) {
        let { appContext } = this.props;
        return <Tooltip key='jobLogs' title='View Logs'><IconButton onClick={() => {
            this.setState({
                dialog: <LogsView width={1200} appContext={appContext} requestId={job.requestId} onDone={() => this.setState({ dialog: null })} />
            });
        }}><LogsIcon /></IconButton></Tooltip>;
    }

    onUpdateCounts() {
        clearTimeout( this.updateCountsTimer );     // kill any previous timer
        this.updateCountsTimer = setTimeout( () => {
            const { model, model: { biomarkers } } = this.state;
            
            if ( this.requestId === undefined ) this.requestId = 0;
            const requestId = ++this.requestId;
            getReportSeries(this.props.appContext,"BiomarkerData", {
                ...biomarkers,
                getCounts: true,
                planId: model.planId
            } ).then((result) => {  
                if ( requestId === this.requestId ) {
                    console.log("onUpdateCounts result:", result );
                    this.setState({counts: result.data.results });
                }
            }).catch((err) => {
                console.error("onUpdateCounts error:", err );
            })
        }, 250 );
    }

    render() {
        const { appContext } = this.props;
        const { tab, model, jobs, deployments, progress, error, dialog, algorithms, imports, counts } = this.state;

        if (!model || algorithms.length === 0) {
            return null;
        }
        if (!model.biomarkers) {
            model.biomarkers = { 
                exported: true, reduce: true, importId: '', dataId: '', tupleIndex: 0, demographics: [], 
                symptoms: [], labs: [], labs_normal: [], labs_high: [], labs_low: [], 
                conditions: [], medications: [], procedures: [] };
        }
        if (model.opts === undefined) model.opts = {};
        const { biomarkers } = model;
        if (biomarkers.exported === undefined) biomarkers.exported = true;
        if (biomarkers.reduce === undefined) biomarkers.reduce = true;
        if (biomarkers.enableExclusive === undefined) biomarkers.enableExclusive = false;

        if (!Array.isArray(biomarkers.demographics)) biomarkers.demographics = [];
        if (!Array.isArray(biomarkers.symptoms)) biomarkers.symptoms = [];
        if (!Array.isArray(biomarkers.proteomicsData)) biomarkers.proteomicsData = [];
        if (!Array.isArray(biomarkers.labs)) biomarkers.labs = [];
        if (!Array.isArray(biomarkers.labs_normal)) biomarkers.labs_normal = [];
        if (!Array.isArray(biomarkers.labs_high)) biomarkers.labs_high = [];
        if (!Array.isArray(biomarkers.labs_low)) biomarkers.labs_low = [];
        if (!Array.isArray(biomarkers.conditions)) biomarkers.conditions = [];
        if (!Array.isArray(biomarkers.medications)) biomarkers.medications = [];
        if (!Array.isArray(biomarkers.procedures)) biomarkers.procedures = [];
        if (!Array.isArray(biomarkers.value)) biomarkers.value = [];
        if (!Array.isArray(biomarkers.conditionTriggers)) biomarkers.conditionTriggers = [];
        if (!Array.isArray(biomarkers.medicationTriggers)) biomarkers.medicationTriggers = [];
        if (!Array.isArray(biomarkers.procedureTriggers)) biomarkers.procedureTriggers = [];

        const jobColumns = [
            //{ id: 'name', label: 'Name' },
            { id: 'status', label: 'Status' },
            { id: 'runWhen', label: 'Start Time', formatValue: (v) => v ? Moment(v).format(DATE_FORMAT) : '' },
            { id: 'recurring', label: 'Recurring', formatValue: (v) => toBoolean(v) ? 'Yes' : 'No' },
            { id: 'keep', label: 'Keep', formatValue: (v) => toBoolean(v) ? 'Yes' : 'No' },
            { id: 'error', label: 'Error' },
            { id: 'createdAt', label: 'Created At', formatValue: (v) => v ? Moment(v).format(DATE_FORMAT) : '' }
        ];

        const selectedAlgorithm = this.algorithmFor(model);
        const algorithmDetails = selectedAlgorithm || { opts: [], description: '' };
        const featureCount = biomarkers.demographics.length + biomarkers.symptoms.length + biomarkers.proteomicsData.length + biomarkers.labs.length + biomarkers.labs_normal.length
            + biomarkers.labs_high.length + biomarkers.labs_low.length + biomarkers.conditions.length + biomarkers.medications.length + biomarkers.procedures.length;
        const triggerCount = biomarkers.conditionTriggers.length + biomarkers.medicationTriggers.length + biomarkers.procedureTriggers.length;

        const onDialogDone = () => {
            this.onCloseDialog();
            this.onUpdateCounts();
        }
        let tabs = [
            <div key='options' style={{ width: 1300, margin: 5}}>
                <div>
                    <TextField style={{ margin: 5, width: 300 }} label="Name" value={model.name}
                        onChange={(e) => {
                            model.name = e.target.value;
                            model.predictorId = createIdFromText(model.name);
                            this.setState({ model, modified: true });
                        }} />
                    <FormControl style={{ margin: 5, width: 300 }}>
                        <InputLabel>Algorithm</InputLabel>
                        <Select value={selectedAlgorithm ? selectedAlgorithm.ref : ''} onChange={(e) => {
                            model.algorithm = e.target.value;
                            this.setState({ model, modified: true });
                        }}>
                            {algorithms.map((e) => <MenuItem key={e.ref} value={e.ref}>
                                {e.name}{e.root === 'system' ? '' : ` (${e.root})`}
                            </MenuItem>)}
                        </Select>
                    </FormControl>
                    <span style={{ display: 'inline-block', width: 500 }}><i>{algorithmDetails.description}</i></span>
                </div>
                <br />
                <TextField style={{ width: '98.5%', margin: 5 }} label="Description" value={model.description} multiline={true} minRows={3} variant='outlined'
                    onChange={(e) => { model.description = e.target.value; this.setState({ model, modified: true }); }} />
                <br />
                <Accordion style={{ margin: 5, marginLeft: 15, marginRight: 15 }}>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>Algorithm Options</AccordionSummary>
                    <AccordionDetails>
                        <div>
                            {/* Typed, the same way the create-job dialog is — a boolean rendered as free
                                text is how "False", "false", "no" and "0" ended up all being possible. */}
                            {algorithmDetails.opts.map((opt) => {
                                if (model.opts[opt.name] === undefined) {
                                    model.opts[opt.name] = opt.defaultValue || '';      // make these all controlled..
                                }
                                return <OptionField
                                    key={opt.name}
                                    opt={opt}
                                    value={model.opts[opt.name]}
                                    style={{ width: '95%' }}
                                    onChange={(value) => {
                                        model.opts[opt.name] = value;
                                        this.setState({ model, modified: true });
                                    }} />
                            })}
                        </div>
                    </AccordionDetails>
                </Accordion>
                <br />
                {this.renderSharing()}
                <br />
                <Accordion style={{ margin: 5, marginLeft: 15, marginRight: 15 }}>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>Patient Filter</AccordionSummary>
                    <AccordionDetails>
                        <div>
                            <Tooltip title='Only use data from patients who have been flagged for export from the production environments'><FormControlLabel label='Exported' control={<Checkbox checked={model.biomarkers.exported} onChange={(e) => {
                                model.biomarkers.exported = e.target.checked;
                                this.setState({ model, modified: true }, this.onUpdateCounts.bind(this))
                            }} />} /></Tooltip>
                            <Tooltip title='Remove features when no patients have data for that feature.'><FormControlLabel label='Reduce' control={<Checkbox checked={model.biomarkers.reduce} onChange={(e) => {
                                model.biomarkers.reduce = e.target.checked;
                                this.setState({ model, modified: true }, this.onUpdateCounts.bind(this))
                            }} />} /></Tooltip>
                            <Tooltip title='If enabled, then all features will be included unless selected.'><FormControlLabel label='Exclude Selected Features' control={<Checkbox checked={model.biomarkers.enableExclusive} onChange={(e) => {
                                model.biomarkers.enableExclusive = e.target.checked;
                                this.setState({ model, modified: true }, this.onUpdateCounts.bind(this))
                            }} />} /></Tooltip>
                            <FormControl style={{ margin: 5, width: 400 }}>
                                <InputLabel>Select Import</InputLabel>
                                <Select value={model.biomarkers.importId} onChange={(e) => {
                                    model.biomarkers.importId = e.target.value;
                                    this.setState({ model, modified: true }, this.onUpdateCounts.bind(this))
                                }}>
                                    <MenuItem value=''>None</MenuItem>
                                    <MenuItem value='*'>All</MenuItem>
                                    {imports.map((imp) => <MenuItem value={imp.importId}>{imp.description}</MenuItem>)}
                                </Select>
                            </FormControl>
                            <br />
                            <SelectDataType style={{ margin: 5, width: 300 }} label='Target Data Type' appContext={appContext} dataId={model.biomarkers.dataId}
                                onCreate={() => {
                                    this.setState({
                                        dialog: <EditDataTypeDialog appContext={appContext}
                                            dataType={{ dataId: '', name: '', description: '', tupleDescriptions: [] }}
                                            onCancel={() => this.setState({ dialog: null })}
                                            onDone={(newType) => {
                                                model.biomarkers.dataId = newType.dataId;
                                                this.setState({ dialog: null, model, modified: true }, this.onUpdateCounts.bind(this));
                                            }} />
                                    });
                                }}
                                onChange={(dataType) => {
                                    model.biomarkers.dataId = dataType ? dataType.dataId : '';
                                    this.setState({ model, modified: true }, this.onUpdateCounts.bind(this));
                                }} />
                            <SelectTupleIndex style={{ margin: 5, width: 300 }} label='Target Tuple Index' appContext={appContext} dataId={model.biomarkers.dataId}
                                tupleIndex={model.biomarkers.tupleIndex}
                                onChange={(e) => {
                                    model.biomarkers.tupleIndex = e;
                                    this.setState({ model, modified: true }, this.onUpdateCounts.bind(this));
                                }} />
                            <br />
                            <TextField style={{ margin: 5, width: 600 }} label="Value Filter" value={model.biomarkers.value.join(',')} helperText={'Must match one of the values (comma seperated, Leave blank for any).'}
                                onChange={(e) => { model.biomarkers.value = e.target.value.split(','); this.setState({ model, modified: true }, this.onUpdateCounts.bind(this)) }} />
                            <TextField style={{ margin: 5, width: 200}} label="Days" helperText="How many days of data to include" type='number' value={model.biomarkers.days} onChange={(e) => {
                                model.biomarkers.days = e.target.value;
                                this.setState({ model, modified: true}, this.onUpdateCounts.bind(this))
                            }} />
                            <br />
                            <EditConditions appContext={appContext} name='Selection Conditions' 
                                value={model.biomarkers.condition} 
                                onChange={((e) => {
                                    model.biomarkers.condition = e;
                                    this.setState({ model, modified: true }, this.onUpdateCounts.bind(this));
                                })} 
                            />
                            <br />
                            <Button style={{ margin: 5 }} variant='contained' onClick={() => 
                                this.setState({ dialog: <FeatureSelectionView appContext={appContext} model={model} onCloseView={onDialogDone} /> })
                            }>Select Features</Button>
                            <Button style={{ margin: 5 }} variant='contained' onClick={() => 
                                this.setState({ dialog: <TriggerSelectionView appContext={appContext} model={model} onCloseView={onDialogDone} /> })
                            }>Select Triggers</Button>
                            <br />
                            <br />
                            <span><i>{featureCount} {biomarkers.enableExclusive ? 'Features Excluded' : 'Features Selected'}, {triggerCount} Triggers Selected.</i></span>
                            {counts.patients !== undefined && <span><i> {counts.patients} Patients Found, {counts.dataPoints} Data points found.</i></span>}
                        </div>
                    </AccordionDetails>
                </Accordion>
            </div>,
            <div key='jobs' style={{ width: 1300, margin: 5}}>
                <EnhancedTable
                    key='jobs'
                    disableMultiSelect={true}
                    onActions={(table, numSelected, actions) => {
                        if (numSelected > 0) {
                            if (numSelected === 1) {
                                const { selected, data } = table.state;
                                let job = data[selected[0]];
                                if (job) {
                                    actions.unshift(<Tooltip title='Add' key='add'><IconButton onClick={() => {
                                        table.setState({ selected: [] });
                                        this.onNewJob();
                                    }}><AddIcon /></IconButton></Tooltip>)
                                    actions.unshift(this.onJobDetails(job));
                                    actions.unshift(this.onToggleKeep(job));
                                    actions.unshift(...this.onJobResult(job));
                                    actions.unshift(this.onJobLogs(job));
                                    actions.unshift(this.onCancelJob(job));
                                    actions.unshift(this.onDeleteJob(job,table));
                                }
                            }
                        }
                    }}
                    disableDelete={true}
                    onAdd={this.onNewJob.bind(this)}
                    orderBy='runWhen'
                    order='desc'
                    columnData={jobColumns}
                    data={jobs}
                    rowsPerPage={15}
                    title='Jobs' />
            </div>,
            <div key='deployments' style={{ width: 1300, margin: 5 }}>
                <EnhancedTable
                    key='deployments'
                    disableMultiSelect={true}
                    disableAdd={true}
                    disableDelete={true}
                    onActions={(table, numSelected, actions) => {
                        if (numSelected !== 1) return;
                        const deployment = table.state.data[table.state.selected[0]];
                        if (!deployment) return;
                        actions.unshift(<Tooltip key='run'
                            title='Run this model against this end-point — no retraining'>
                            <IconButton onClick={() => {
                                table.setState({ selected: [] });
                                this.onRunWithDeployment(deployment);
                            }}><PlayIcon /></IconButton></Tooltip>);
                        actions.unshift(<Tooltip key='shutdown'
                            title='Delete these end-points in SageMaker and stop them billing'>
                            <IconButton onClick={() => {
                                table.setState({ selected: [] });
                                this.onDeleteDeployment(deployment);
                            }}><DeleteIcon /></IconButton></Tooltip>);
                    }}
                    orderBy='createdAt'
                    order='desc'
                    columnData={[
                        { id: 'createdAt', label: 'Deployed',
                            formatValue: (v) => (v ? Moment(v).format(DATE_FORMAT) : '') },
                        { id: 'algorithm', label: 'Algorithm' },
                        { id: 'outputs', label: 'End-points',
                            formatValue: (v) => Object.keys(v || {})
                                .map((k) => `${k}=${v[k]}`).join(', ') },
                        { id: 'jobId', label: 'From job' }
                    ]}
                    data={deployments}
                    title='Deployments' />
                {/* Still worth saying, because the cost is ongoing and invisible from here. */}
                <div style={{ margin: 10, opacity: 0.75 }}>
                    An end-point stays up after a run whose options asked it to. Running against one skips
                    training entirely and applies the already-trained model to whatever the cohort holds
                    now. <b>Each one bills for as long as it exists</b>, so shut down the ones you have
                    finished with — the trained model survives, and a later run can stand a new end-point up
                    from it without retraining.
                </div>
            </div>
        ];

        let disableDelete = model.planId !== appContext.state.plan.planId;
        return (
            <div align="center" >
                <AppBar style={{ backgroundColor: "#FF9800", width: '100%'}} position="static">
                    <Toolbar>
                        <IconButton onClick={() => this.onCloseView()}>
                            <NavigationClose />
                        </IconButton>
                        <Typography variant="h6" color="inherit">ML Model</Typography>
                    </Toolbar>
                </AppBar>

                <div align="left" style={{ margin: 0}}>
                    <table style={{ width: '100%' }}>
                        <tbody>
                            <tr>
                                <td>
                                    <TextField disabled={true} style={{margin: 5, width: 400}} label="Model ID" value={model.modelId}
                                        onChange={(e) => { model.modelId = e.target.value; this.setState({ model, modified: true }); }} />
                                </td>
                                <td valign="top" align="right">
                                    <span style={{color: 'red'}}>{error}</span>
                                    <Tooltip title='Save'><IconButton disabled={progress !== null} onClick={this.onSaveMLModel.bind(this, false)}>{progress || <SaveIcon />}</IconButton></Tooltip>
                                    <Tooltip title='Duplicate'><IconButton disabled={progress !== null} onClick={this.onSaveMLModel.bind(this, true)}>{progress || <SaveCopyIcon />}</IconButton></Tooltip>
                                    <Tooltip title='Show JSON'><IconButton onClick={this.onShowCode.bind(this)}><CodeIcon /></IconButton></Tooltip>
                                    <Tooltip title='Delete'><IconButton disabled={disableDelete} onClick={this.onDeleteMLModel.bind(this)}><DeleteIcon /></IconButton></Tooltip>
                                </td>
                            </tr>
                            <tr>
                                <td colSpan="2">
                                    <Tabs style={{ width: '100%', backgroundColor: '#96b7eb' }}
                                        value={tab} onChange={(e, newTab) => { this.setState({ tab: `${newTab}` }); }}>
                                        <Tab label='Options' value='0' />
                                        <Tab label='Jobs' value='1' />
                                        <Tab label={`Deployments${deployments.length
                                            ? ` (${deployments.length})` : ''}`} value='2' />
                                    </Tabs>
                                    {tabs[tab]}
                                    <br />
                                    <div style={{ margin: 5 }}>
                                        <ChangedByButton appContext={this.props.appContext} primaryKey={model.modelId} collection='MLModel' />
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                {dialog}
            </div>
        );
    }
}

export default MLModelView;
